<template>
	<div>
		<div @click="drawer = true" class="fz-12 color-gy-8 cursor-pointer">
			<i class="el-icon-collection fz-12"></i>
			指标说明
		</div>
		<el-drawer :title="title" :visible.sync="drawer" :size="600" custom-class="drawer-template drawerFieldDesc">
			<div class="yx-background p-20" style="min-height:100%">
				<div class="white-bg p-16 mb-8 radius-8" v-for="(item, index) in descList" :key="index">
					<div class="color-gy-9 fz-14 font-h4-medium mb-6">
						{{ item.title }}
					</div>
					<div class="color-gy-8 fz-14">
						{{ item.desc }}
					</div>
				</div>
				<div style="height:53px" />
			</div>
			<div class="drawer-footer white-bg">
				<el-button type="primary" @click="drawer = false">我知道了</el-button>
			</div>
		</el-drawer>
	</div>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			default: '',
		},
		descList: {
			type: Array,
			default: _ => [],
		},
	},
	data() {
		return {
			drawer: false,
		};
	},
};
</script>

<style lang="less">
.drawerFieldDesc {
	.el-drawer__body {
		padding: 0 !important;
	}
}
</style>
